// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"880db3fd","739":"4c4cc8f1"}[chunkId] + ".chunk.js";
};